export const styles = {
    
    tableRow: {
        cursor: "default"
    }
}